@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.textSecondary {
  color:  hevo-toolkit-variables.$text-secondary !important;
}
